"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Fields = require("./Fields");

var _Fields2 = _interopRequireDefault(_Fields);

var _semanticUiReact = require("semantic-ui-react");

var _FormHelper = require("../../helpers/FormHelper");

var formHelper = _interopRequireWildcard(_FormHelper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputField = function (_React$Component) {
    _inherits(InputField, _React$Component);

    function InputField(props) {
        _classCallCheck(this, InputField);

        var _this = _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).call(this, props));

        _this.onChange = function (event) {
            if (_this.props.textarea) {
                if (event.target.value.length === 0) event.target.style.height = '34px';
                if (event.target.scrollHeight > 34 && event.target.scrollHeight < _this.props.rows * 19.3) event.target.style.height = event.target.scrollHeight + 'px';
                event.target.style.overflow = 'hidden';
                if (event.target.scrollHeight > _this.props.rows * 19.3) event.target.style.overflow = 'auto';
            }

            if (_this.props.maxLength) _this.handlerMaxLength(event);

            _this.props.number ? _this.onlyNumberEvent(event) : _this.props.onChange(event, event.target);
        };

        _this.handlerMaxLength = function (e) {
            _this.props.onChange(e, e.target);
            if (e.target.value.length > _this.props.maxLength) {
                var value = e.target.value;
                e.target.value = value.substring(0, _this.props.maxLength);
            }
            _this.setState({ value: e.target.value.length });
        };

        _this.onlyNumberEvent = function (event) {
            _this.input.value = _this.input.value.replace(/\D/, '');
            _this.props.onChange(event, event.target);
        };

        _this.onBlur = function (event) {
            _this.setState({
                touched: true,
                untouched: false,
                focused: false,
                disabled: _this.state.disabled,
                fieldClass: _this.getFieldValidation({
                    touched: true,
                    untouched: false,
                    valid: _this.isValid(event.target.value),
                    invalid: !_this.isValid(event.target.value),
                    focused: false
                })
            });
            if (_this.props.capitalize) event.target.value = formHelper.capitalize(event.target.value);
            if (_this.props.onChange) _this.props.onChange(event, event.target);
            if (_this.props.onBlur) _this.props.onBlur(event, event.target);
        };

        _this.validRequired = function (value) {
            if (_this.props.required) {
                if (typeof value === 'string') return value.trim().length > 0;else return value !== null && value !== undefined;
            } else return true;
        };

        _this.getInputFields = function () {
            var labeled = _this.props.labeled === undefined ? null : _this.props.labeled;
            return _this.props.className === 'ui calendar' ? _react2.default.createElement("input", { id: _this.props.name, className: _this.getClass(), ref: function ref(input) {
                    _this.input = input;
                }, name: _this.props.name, value: _this.props.value, defaultValue: _this.props.defaultValue,
                required: _this.props.required, placeholder: _this.props.placeholder, onBlur: _this.onBlur, onFocus: _this.onFocus,
                onChange: _this.onChange, type: _this.props.type, disabled: _this.state.disabled }) : !_this.props.textarea ? _react2.default.createElement("input", { id: _this.props.name, className: _this.getClass(), ref: function ref(input) {
                    _this.input = input;
                }, name: _this.props.name, value: _this.props.value,
                required: _this.props.required, placeholder: _this.props.placeholder, onBlur: _this.onBlur, onFocus: _this.onFocus,
                onChange: _this.onChange, type: _this.props.type, disabled: _this.state.disabled }) : _react2.default.createElement(_semanticUiReact.TextArea, { id: _this.props.name, label: labeled, className: "border-bottom-primary", ref: function ref(input) {
                    _this.input = input;
                }, name: _this.props.name, value: _this.props.value,
                required: _this.props.required, placeholder: _this.props.placeholder, spellCheck: _this.props.spellcheck, onBlur: _this.onBlur, onFocus: _this.onFocus,
                onChange: _this.onChange, disabled: _this.state.disabled });
        };

        _this.getDica = function () {
            if (_this.props.dica && (_this.state.untouched || _this.state.touched && _this.state.focused)) {
                return _react2.default.createElement(
                    "span",
                    { className: "field-message dica" },
                    _this.props.dica
                );
            }
        };

        _this.state = {
            untouched: true,
            touched: false,
            focused: false,
            value: _this.props.value || "",
            disabled: _this.props.disabled,
            fieldClass: _this.getFieldValidation({
                untouched: true,
                touched: false,
                dirty: false,
                invalid: !_this.isValid(_this.props.value || ""),
                valid: _this.isValid(_this.props.value || ""),
                focused: false })
        };
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        return _this;
    }

    _createClass(InputField, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {

            if (nextProps.disabled != this.state.disabled) this.setState({ disabled: nextProps.disabled });
            if (nextProps.value && nextProps.value !== this.state.value && nextProps.value !== undefined || nextProps.className === 'ui calendar' && this.state.value.trim().length === 0
            // || (nextProps.required && this.state.value.trim().length === 0) // para que você serve?
            ) {
                    this.setState({
                        fieldClass: this.getFieldValidation({
                            touched: this.state.touched,
                            untouched: this.state.untouched,
                            valid: this.isValid(nextProps.value),
                            invalid: !this.isValid(nextProps.value)
                        })
                    });
                }

            if (nextProps.className === 'ui calendar' && nextProps.defaultValue) {
                this.setState({
                    fieldClass: this.getFieldValidation({
                        touched: this.state.touched,
                        untouched: this.state.untouched,
                        valid: this.isValid(nextProps.defaultValue),
                        invalid: !this.isValid(nextProps.defaultValue)
                    })
                });
            }

            if (nextProps.className === 'ui calendar' && this.state.touched && (nextProps.defaultValue === undefined || nextProps.defaultValue === null)) {
                this.setState({
                    fieldClass: this.getFieldValidation({
                        untouched: true,
                        invalid: true
                    })
                });
            }

            if (nextProps.validateMessage) {
                this.setState({
                    fieldClass: this.getFieldValidation({
                        untouched: false,
                        touched: true,
                        valid: false,
                        invalid: true
                    })
                });
            }
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            if (this.props.accept) {
                document.getElementById(this.props.name).setAttribute("accept", this.props.accept);
            }

            if (this.props.multiple) {
                document.getElementById(this.props.name).setAttribute("multiple", true);
            }

            if (this.props.minLength) {
                // validando o tamanho minimo com pattern e title, obs:a propiedade 'minlength' não funciona em conjunto da propiedade 'value' no input
                var input = document.getElementById(this.props.name);
                if (input) {
                    input.setAttribute('pattern', ".{" + this.props.minLength + ",}");
                    input.setAttribute('title', "M\xEDnimo de caracteres obrigatorios: " + this.props.minLength);
                }
            }
        }
    }, {
        key: "isValid",
        value: function isValid(value) {
            if (this.props.required || this.props.maxLength || this.props.minLenth || this.props.email || this.props.equal || this.props.pattern) {
                var valid = false;
                if (this.props.maxLength) {
                    if (this.validRequired(value)) valid = typeof value === 'string' ? value.length <= this.props.maxLength : value <= this.props.maxLength;
                }
                if (this.validRequired(value)) valid = true;
                if (this.props.equal) {
                    valid = this.props.equal === value;
                    if (!valid) return false;
                }
                if (this.props.pattern) String(value).match(this.props.pattern) != null ? valid = true : valid = false;
                if (value && this.props.email) value.match(/^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/g) != null ? valid = true : valid = false;
                if (this.props.minLength) valid = typeof value === 'string' ? value.length >= this.props.minLength : value >= this.props.minLength;
                return valid;
            } else return true;
        }
    }, {
        key: "getClass",
        value: function getClass() {
            var estilo = "md-input border-bottom-primary";
            if (this.props.icon) estilo = estilo + " md-input-icon-" + (this.props.iconPosition || "left");
            if (this.props.buttonAction) estilo = estilo + " md-input-btn-" + (this.props.buttonPosition || "left");
            return estilo;
        }
    }, {
        key: "getFieldValidation",
        value: function getFieldValidation(state) {
            var estilo = this.props.className ? this.props.className : "";
            if (state.touched) estilo = estilo + " touched";
            if (state.untouched) estilo = estilo + " untouched";
            if (state.dirty) estilo = estilo + " dirty";
            if (state.valid) estilo = estilo + " valid";
            if (state.invalid) estilo = estilo + " invalid";
            if (state.focused) estilo = estilo + " focused";
            if (this.props.required || this.props.maxLength || this.props.minLenth || this.props.email || this.props.equal || this.props.pattern) estilo = estilo + " validate";
            return estilo;
        }
    }, {
        key: "onFocus",
        value: function onFocus(e, data) {
            data = e.target;
            this.setState({
                untouched: false,
                touched: true,
                focused: true,
                disabled: this.state.disabled,
                fieldClass: this.getFieldValidation({
                    touched: true,
                    untouched: false,
                    valid: this.isValid(e.target.value),
                    invalid: !this.isValid(e.target.value),
                    focused: true
                })
            });

            if (this.props.onFocus) {
                this.props.onFocus(e, data);
            }
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                _Fields2.default,
                { className: this.state.fieldClass, width: this.props.width, required: this.props.required, icon: this.props.icon,
                    name: this.props.name, label: this.props.label, validateMessage: this.props.validateMessage || this.props.invalidMessage,
                    iconPosition: this.props.iconPosition, phoneWidth: this.props.phoneWidth, tabletWidth: this.props.tabletWidth,
                    currentValue: this.state.value, maxLength: this.props.maxLength, buttonAction: this.props.buttonAction,
                    buttonPosition: this.props.buttonPosition },
                this.getInputFields(),
                this.getDica(),
                this.props.children
            );
        }
    }]);

    return InputField;
}(_react2.default.Component);

exports.default = InputField;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/form/InputField.js
// module id = 345
// module chunks = 0